module.exports = __webpack_public_path__ + "img/tiaoshi.f46846a5.png";